export const checkVersion = async () => {
    const response = await fetch('/index.html', { cache: 'no-cache' });
    const text = await response.text();
    const match = text.match(/<meta name="app-version" content="(.+?)"/);
  
    const latestVersion = match?.[1];
    const currentVersion = localStorage.getItem('app-version');
  
    if (latestVersion && currentVersion && latestVersion !== currentVersion) {
      // 🔁 Force reload
      window.location.reload(true);
    }
  
    // 🔐 Save latest version
    if (latestVersion) {
      localStorage.setItem('app-version', latestVersion);
    }
  };
  